export const QuoteDetailsSkeleton = () => {
  return (
    <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8 animate-pulse">
      <div className="flex flex-col sm:flex-row sm:items-center">
        <div className="flex-shrink-0 w-full sm:w-40 h-40 bg-gray-300 dark:bg-gray-700 rounded-2xl"></div>
        <div className="py-5 sm:px-5 space-y-3 flex-grow">
          <div className="w-1/3 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="w-1/2 h-6 bg-gray-300 dark:bg-gray-700 rounded mt-2"></div>
          <div className="w-1/3 h-4 bg-gray-300 dark:bg-gray-700 rounded mt-2"></div>
          <div className="w-10 h-px bg-gray-300 dark:bg-gray-700 mt-4"></div>
        </div>
      </div>

      <div className="flex justify-between space-y-2">
        <div className="w-1/3 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div className="w-1/3 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div className="w-1/4 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
      </div>

      <div className="space-y-4">
        <div className="h-8 w-1/3 bg-gray-300 dark:bg-gray-700 rounded"></div>
        <div className="flex justify-between items-center">
          <div className="w-1/4 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="w-1/5 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="border-b border-neutral-200 dark:border-neutral-700 my-4"></div>
        <div className="flex justify-between font-semibold">
          <div className="w-1/4 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="w-1/5 h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
    </div>
  );
};
